import { backend } from '../services';
import { fetch as fetchRaw } from '@lib/fetch';
import { getDefinedUrlSearchParams } from '@lib/util';
import type { IEntityScreeningV2Params, IEntityScreeningV2Response, IMatchingThresholdResponse } from '@views/entity-screening-v2/types/Index';

const fetch = (url: string, ...args: any[]) => fetchRaw([backend.url, url], ...args);

export async function fetchEntityScreeningV2List(
  params: IEntityScreeningV2Params,
): Promise<IEntityScreeningV2Response> {
  const searchParams = getDefinedUrlSearchParams({
    page: params.page,
    limit: params.limit,
    sort: params.sort,
    filter: params.filter,
  });

  const response = await fetch(`/entity-screening/companies?${searchParams}`, { method: 'GET' });
  if (response.error) {
    throw new Error(response.error.message || 'Failed to fetch entity screening list');
  }
  return response;
}

export async function getMatchingThreshold(): Promise<IMatchingThresholdResponse> {
  const response = await fetch('/entity-screening/threshold', { method: 'GET' });
  if (response.error) {
    throw new Error(response.error.message || 'Failed to fetch matching threshold');
  }
  return response;
}

export async function updateMatchingThreshold(scoreThresholdValue: number): Promise<void> {
  const response = await fetch('/entity-screening/threshold', {
    method: 'PUT',
    body: JSON.stringify({ scoreThresholdValue }),
  });
  if (response.error) {
    throw new Error(response.error.message || 'Failed to update matching threshold');
  }
}

export async function validateMatchResults(
  flaggedIds: string[],
  dismissedIds: string[],
): Promise<void> {
  const response = await fetch('/entity-screening/matches/validate', {
    method: 'PUT',
    body: JSON.stringify({ flaggedIds, dismissedIds }),
  });
  if (response.error) {
    throw new Error(response.error.message || 'Failed to update validation status');
  }
}
